<script setup lang="ts">
import BaseQuestionSlider from '@/components/base/BaseQuestionSlider.vue';
import { Locales } from '@/store/language.interface';
import { getLabel } from '@/utils/data-display-utils';

// PROPS
const props = defineProps<{
  levels: any;
  statistiques?: any;
  showResult?: boolean;
  languageEnabled?: Locales[];
  showStats?: boolean;
  response?: any[];
}>();

// EMITS
const emit = defineEmits<{
  (e: 'change', response: any): void;
}>();

// FUNCTIONS
function changeValue(value: any) {
  emit('change', value);
}
</script>

<template>
  <div class="slider-container">
    <div class="slider-container__title q-mb-md" v-if="!showResult">
      <span>{{ getLabel('form.steps.levels', props.languageEnabled) }}</span>
    </div>

    <div v-if="!showResult" class="question">
      <div class="slider-container__slider" v-for="slider in props.levels">
        <BaseQuestionSlider :slider="slider" :language-enabled="props.languageEnabled" @change="changeValue($event)" />
      </div>
    </div>

    <div v-if="showResult && props.showStats" class="result">
      <div class="result_container" v-for="slider in props.levels">
        <BaseQuestionSlider
          v-if="statistiques && statistiques.step[slider.answerId][0]"
          :slider="slider"
          results
          :average="statistiques.step[slider.answerId][0].average"
          :language-enabled="props.languageEnabled"
        />
      </div>
    </div>
    <div
      v-else-if="showResult && !props.showStats && props.response && props.response[0]?.votes.length > 1"
      class="result"
    >
      <div class="result_container" v-for="slider in props.levels">
        <BaseQuestionSlider
          :slider="slider"
          results
          :average="props.response[0]?.votes.filter((r) => r.answer_id === slider.answerId)[0]?.value_id[0]"
          :language-enabled="props.languageEnabled"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.slider-container {
  width: 100%;
  border-radius: 8px;
  margin: $space-sm 0;
  padding: $space-xs;

  &__result {
    display: flex;
    flex-direction: column;
  }

  .result {
    display: flex;
    flex-direction: row;
    width: inherit;
    gap: $space-md;

    &_container {
      width: 100%;
    }
  }
}
</style>
